import React, { useState } from 'react';
import { FiCheck } from 'react-icons/fi';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Seo from '../Components/Seo';
import CheckoutModal from '../Components/pricing/CheckoutModal';
import { customPlanIncludes, customPlans, formatInr, lifetimePlans } from '../data/pricingPlans';
import { breadcrumbSchema, organizationSchema } from '../data/seo';
import '../assests/css/pricing.css';

function PlanCard({ plan, onBuy }) {
  return (
    <article className={`pricing-card${plan.popular ? ' is-popular' : ''}${plan.variant === 'custom' ? ' is-custom' : ''}`}>
      <div className="pricing-card-top">
        <div className="pricing-card-codes">
          <span className="pricing-plan-code">{plan.code}</span>
          {plan.badge ? <span className="pricing-plan-chip">{plan.badge}</span> : null}
          {plan.popular ? <span className="pricing-popular">Most Popular</span> : null}
        </div>
        <h3>{plan.name}</h3>
        <p className="pricing-card-blurb">{plan.blurb}</p>
      </div>

      <div className="pricing-card-price">
        <span className="pricing-starting">Starting from</span>
        <strong>{formatInr(plan.amount)}</strong>
        <span className="pricing-card-meta">{plan.meta}</span>
      </div>

      <ul className="pricing-features">
        {plan.features.map((feature) => (
          <li key={feature}>
            <span className="pricing-check" aria-hidden="true">
              <FiCheck />
            </span>
            {feature}
          </li>
        ))}
      </ul>

      <button type="button" className={`pricing-buy pricing-buy-${plan.variant}`} onClick={() => onBuy(plan)}>
        {plan.cta}
      </button>
    </article>
  );
}

function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [bannerError, setBannerError] = useState('');

  const onBuy = (plan) => {
    setBannerError('');
    setSelectedPlan(plan);
  };

  return (
    <div className="pricing-page">
      <Seo
        path="/pricing"
        schema={[organizationSchema, breadcrumbSchema('/pricing', 'Pricing')]}
      />
      <Header />
      <main className="pricing-main">
        <section className="pricing-section">
          <div className="container">
            <div className="pricing-head">
              <p className="pricing-kicker">Lifetime license</p>
              <h1>
                Non-Customizable Plan <span>(For Small Schools)</span>
              </h1>
              <p className="pricing-lead">
                Designed for small schools looking for an affordable and reliable ERP solution with
                essential tools. One-time setup cost with mandatory yearly renewal. Renewal available
                with minimal server and maintenance charges for updates, backup, and technical support.
              </p>
            </div>

            {bannerError ? <p className="pricing-banner-error">{bannerError}</p> : null}

            <div className="pricing-grid">
              {lifetimePlans.map((plan) => (
                <PlanCard key={plan.id} plan={plan} onBuy={onBuy} />
              ))}
            </div>
          </div>
        </section>

        <section className="pricing-section pricing-section-custom">
          <div className="container">
            <div className="pricing-head">
              <p className="pricing-kicker is-custom">Fully customizable</p>
              <h2>
                Custom ERP Solutions <span>(Tailored for Your Institution)</span>
              </h2>
              <p className="pricing-lead">
                Get exactly what your institution needs — marksheet, bonafide certificate, report card,
                transfer certificate, character certificate, ID card, admit card, and dedicated modules
                including payment gateway, mobile apps, and biometric integration.
              </p>
            </div>

            <div className="pricing-grid">
              {customPlans.map((plan) => (
                <PlanCard key={plan.id} plan={plan} onBuy={onBuy} />
              ))}
            </div>

            <p className="pricing-footnote">{customPlanIncludes}</p>
          </div>
        </section>
      </main>
      {selectedPlan ? (
        <CheckoutModal
          plan={selectedPlan}
          onClose={() => setSelectedPlan(null)}
          onError={setBannerError}
        />
      ) : null}
      <Footer />
    </div>
  );
}

export default Pricing;
